import { Transforms } from 'slate'

import { isCheckboxListFeasible } from './isCheckboxListFeasible.js'

export function insertCheckboxList (editor) {
  const { selection } = editor
  if (!selection) {
    return
  }

  const isFeasible = isCheckboxListFeasible(editor)
  if (!isFeasible) {
    return
  }

  const node = {
    type: 'checkbox-list-item',
    isChecked: false,
    children: [{
      text: ''
    }]
  }

  Transforms.insertNodes(editor, node, {
    hanging: false
  })
}
